import { APIs } from "../../../../../../util/api/APIs";
import SafeairManager from "../../../../../../util/api/SafeairManager";

class PermissionsService {
  async listAllPermissions() {
    const response = SafeairManager.invoke({
      api: APIs.Permission.ListAllPermissions,
      parameters: {
        search: "",
      },
      body: null,
    });
    return (await response).data;
  }
}

export default new PermissionsService();
